/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @next/next/no-img-element */
import { MouseEventHandler, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import Link from 'next/link';
import { IconButton, Tooltip, withStyles } from '@material-ui/core';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import {
  MdArrowDropDown,
  MdPersonOutline,
  MdMailOutline,
} from 'react-icons/md';
import { HiOutlinePhone, HiOutlineVideoCamera } from 'react-icons/hi';
import * as Sentry from '@sentry/nextjs';

import { AppSidebar } from '@/components/custom/sidebar/app-sidebar';
import { Separator } from '@/components/ui/separator';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import MainArea from '@/components/custom/main-section/main-area';
import { CrossIcon } from 'lucide-react';
import styles from './header.module.css';
import ConversationIcon from '../../public/icons/conversation-icon.svg';
import ShareIcon from '../../public/icons/shared-page-icon.svg';
import SetupIcon from '../../public/icons/setup-icon.svg';
import AllConversationIcon from '../../public/icons/all-conversations.svg';
import ChartIcon from '../../public/icons/chart-icon.svg';
import SpeechInfoIcon from '../../public/icons/icon-speech-info.svg';
import OpenArrowIcon from '../../public/icons/open-arrow.svg';
import BugIcon from '../../public/icons/bug.svg';
import { HELP_CENTER_LINK_URL, PARTNERS, ROUTES } from '../../utils/constants';
import { RootState } from '../../store/reducers';
import WorkspaceSelectionList from '../WorkspaceSelectionList/WorkspaceSelectionList.component';
import {
  METABASE_DASHBOARDS,
  METABASE_UNAVAILABLE,
  SAVE_USER,
  SET_FREE_TIER_SUBSCRIPTION_DETAILS,
  SET_IS_PAYMENT_METHOD_ADDED,
  SET_SELECTED_WORKSPACE,
} from '../../store/types';
import UserService from '../../services/user/user.service';
import OrganisationService from '../../services/organisation/organisation.service';
import ReportIssueModal from '../report-issue-modal/report-issue-modal';
import { getSubscriptionDetails } from '../../handlers/handlers';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarRail,
  SidebarTrigger,
} from '../ui/sidebar';
import useInIframe from '../../hooks/useInIframe';
// import VIPIcon from '../../public/icons/vip.svg';
// import AvailabilitySwitch from '../AvailabilitySwitch/availability-switch.component';
// import WarningTriangle from '../../public/icons/warning-triangle.svg';
// import ChromePerfIcon from '../../public/icons/chrome-perf-ss.svg';
// import InfoIcon from '../../public/icons/white-info.svg';

interface ISideHeader {
  branding: {
    headerText: string;
  };
  workspaceAdminDetails: {
    first_name: string;
    last_name: string;
    email: string;
  };
  children: ReactNode;
}

const CustomToolTip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#122832',
    color: '#ffffff',
    fontSize: 14,
    padding: '8px',
  },
}))(Tooltip);

// const SideHeader = ({ branding, workspaceAdminDetails }: ISideHeader): JSX.Element => {
const SideHeader = (props: ISideHeader): JSX.Element => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  const { branding, workspaceAdminDetails, children } = props;
  const [isPaymentMethodAdded, setIsPaymentMethodAdded] = useState<boolean>(false);


  const handleActionClick = () => {
    if (successPage) {
      setSuccessPage(false);
      setShowReportIssueBox(false);
    } else {
      const eventId = Sentry.captureMessage('User Feedback');
      const userFeedback = {
        event_id: eventId,
        name: user.first_name,
        email: user.email,
        userId: user.id,
        comments: issueText,
      };
      Sentry.captureUserFeedback(userFeedback);
      setIssueText('');
      setSuccessPage(true);
    }
  }

  const handleSecondaryAction = () => {
    setSuccessPage(false);
  }

  const handleReportIssueModalClose = () => {
    setShowReportIssueBox(false);
  }

  const getMetabaseDashboard = async id => {
    const metabaseDashboardResponse =
      await OrganisationService.getMetabaseDashboard(id);
    const metabaseDashboardsData = metabaseDashboardResponse?.data.data;
    dispatch({
      type: METABASE_DASHBOARDS,
      payload: metabaseDashboardsData || [],
    });
  };

  const isMetabaseUnavailable = (dashboards, featuresList) => {
    const enabledFeatures = new Set(
      (featuresList || [])
        .filter(feature => feature.enabled)
        .map(feature => feature.feature)
    );

    return dashboards && Array.isArray(dashboards) && Boolean(dashboards?.length) && dashboards.every(dashboard => {
      const flags = dashboard?.feature_flags;

      return flags && flags.length > 0 && flags.some(flag => !enabledFeatures.has(flag));
    });
  };

  const dispatch = useDispatch();
  const router = useRouter();
  const { asPath, isReady } = router;

  const [selectedListAction, setSelectedListAction] = useState<string>('');
  const [workspaceDropdownOpen, setWorkspaceDropdownOpen] = useState(false);
  const [activeWorkspace, setActiveWorkspace] = useState<string>('');
  const [showReportIssueBox, setShowReportIssueBox] = useState(false);
  const [issueText, setIssueText] = useState('');
  const [successPage, setSuccessPage] = useState(false);

  const { user, workspaces, selectedWorkspace, isAdmin, isSuperAdmin, metabaseDashboards, features } = useSelector(
    (state: RootState) => state.common,
  );

  useEffect(() => {
    if (metabaseDashboards?.length) {
      const res = isMetabaseUnavailable(metabaseDashboards, features);
      dispatch({
        type: METABASE_UNAVAILABLE,
        payload: res
      })
    }
  }, [metabaseDashboards, features])


  // Determine active workspace name
  useEffect(() => {
    if (user && workspaces?.length) {
      const stored = JSON.parse(
        localStorage.getItem('selected_workspace') || '[]',
      );
      const prefId =
        isSuperAdmin && stored.length
          ? stored[0].id
          : user.workspace_preference_id;
      const wp = workspaces.find(w => w.id === prefId);
      if (wp) setActiveWorkspace(wp.name);
    }
  }, [user, workspaces, isSuperAdmin]);

  const handleSelectWorkspace = async (item: any) => {
    const filtered: any =
      workspaces &&
      workspaces?.find(workspaceItem => workspaceItem?.id === item?.id);

    dispatch({ type: SET_SELECTED_WORKSPACE, payload: [filtered] });
    localStorage.setItem('selected_workspace', JSON.stringify([filtered]));
    if (typeof filtered?.id === 'number' && (isAdmin || isSuperAdmin)) {
      await getMetabaseDashboard(filtered?.id);
    }
    window.location.reload();
  };


  const getPrefWorkspaceId = () => {
    const selectedWpFromStorage = window && window.localStorage && JSON.parse(localStorage.getItem('selected_workspace'));
    if (isSuperAdmin && selectedWpFromStorage && selectedWpFromStorage?.length) {
      return Number(selectedWpFromStorage?.[0]?.id)
    } else {
      return user?.workspace_preference_id
    }
  }

  const getSubscriptionData = async () => {
    try {
      const subsData: any = await getSubscriptionDetails(selectedWorkspace?.[0]?.organisation_id);
      const freeTierSubscriptionDetails = subsData?.subscriptionDetails
      const isFreeTierPaymentMethodAdded = subsData?.isPaymentMethodAdded || false;
      setIsPaymentMethodAdded(isFreeTierPaymentMethodAdded);
      dispatch({
        type: SET_FREE_TIER_SUBSCRIPTION_DETAILS,
        payload: freeTierSubscriptionDetails,
      });
      dispatch({
        type: SET_IS_PAYMENT_METHOD_ADDED,
        payload: isFreeTierPaymentMethodAdded,
      });
    } catch (error) {
      console.log({error})
    }
  }

  useEffect(() => {
    if (user && workspaces && workspaces.length) {
      const wpId = getPrefWorkspaceId()
      const workspace = workspaces && workspaces.length && workspaces.find((item) => item.id === wpId);
      setActiveWorkspace(workspace?.name);
    }
  }, [user, workspaces, selectedWorkspace]);

  useEffect(()=>{
    if(selectedWorkspace?.[0]?.organisation_id){
      getSubscriptionData();
    }
  },[selectedWorkspace])

  return (
    <SidebarProvider>
      <AppSidebar
        branding={branding}
        activeWorkspace={activeWorkspace}
        handleSelectWorkspace={handleSelectWorkspace}
        workspaceAdminDetails={workspaceAdminDetails}
        selectedWorkspace={selectedWorkspace}
      />
      <MainArea setShowReportIssueBox={setShowReportIssueBox}>
        {children}
      </MainArea>     

      {/* Report Issue Modal */}
      {showReportIssueBox && (
        <ReportIssueModal
          isMenuOpen
          closeModal={handleReportIssueModalClose}
          issueText={issueText}
          successPage={successPage}
          updateIssueText={setIssueText}
          handlePrimaryAction={handleActionClick}
          handleSecondaryAction={handleSecondaryAction}
        />
      )}
    </SidebarProvider>
  );
};

export default SideHeader;
